document.addEventListener('DOMContentLoaded', () => {
  const productGrid = document.querySelector('#product-grid');
  let sentinel = document.querySelector('#infinite-scroll-sentinel');
  const loader = document.querySelector('#infinite-scroll-loader');

  if (!productGrid || !sentinel) {
    console.warn('Infinite Scroll: Missing #product-grid or #infinite-scroll-sentinel');
    return;
  }

  let loading = false;

  const loadMoreProducts = async () => {
    if (loading) return;

    const nextUrl = sentinel.getAttribute('data-next-url');
    if (!nextUrl) {
      console.log('Infinite Scroll: No more pages to load');
      observer.unobserve(sentinel);
      return;
    }

    loading = true;
    if (loader) loader.style.display = 'block';

    console.log('Infinite Scroll: Loading from:', nextUrl);

    try {
      const res = await fetch(nextUrl);
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');

      const newItems = doc.querySelectorAll('#product-grid > li');
      newItems.forEach(item => productGrid.appendChild(item));

      /* 🔥 Re-init Stamped reviews for newly appended products */
      refreshStamped();

      const newSentinel = doc.querySelector('#infinite-scroll-sentinel');
      if (newSentinel) {
        sentinel.setAttribute('data-next-url', newSentinel.getAttribute('data-next-url'));
      } else {
        console.log('Infinite Scroll: No more pages');
        observer.unobserve(sentinel);
        sentinel.remove();
        if (loader) loader.remove();
      }
    } catch (e) {
      console.error('Infinite Scroll: Error loading products', e);
    }

    loading = false;
    if (loader) loader.style.display = 'none';
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        console.log('Infinite Scroll: Sentinel is visible. Triggering load.');
        loadMoreProducts();
      }
    });
  }, {
    rootMargin: '300px',
    threshold: 0.5 // Load when half the sentinel is visible
  });

  observer.observe(sentinel);
});


// document.addEventListener('DOMContentLoaded', () => {
//   const productGrid = document.getElementById('product-grid');
//   if (!productGrid) return;

//   const items = Array.from(productGrid.querySelectorAll('li.grid__item'));
  
//   // Helper function to get rating number from inside product card
//   function getRating(li) {
//     const ratingEl = li.querySelector('.rating-count');  // Change selector if your rating is elsewhere
//     if (!ratingEl) {
//       console.log('No rating element found in item:', li);
//       return 0;
//     }
//     const ratingText = ratingEl.textContent.trim();
//     const ratingNum = parseFloat(ratingText);
//     if (isNaN(ratingNum)) {
//       console.log('Invalid rating number:', ratingText);
//       return 0;
//     }
//     return ratingNum;
//   }

//   // Sort the <li> elements by rating descending
//   items.sort((a, b) => getRating(b) - getRating(a));

//   // Re-append sorted items to the container
//   items.forEach(item => productGrid.appendChild(item));

//   console.log('Products sorted by rating descending.');
// });

